import { render, staticRenderFns } from "./EditResearchAreaDetail.vue?vue&type=template&id=788f8aa4"
import script from "./EditResearchAreaDetail.vue?vue&type=script&lang=js"
export * from "./EditResearchAreaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports